import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link as RouterLink } from 'react-router-dom';
import { DateTime } from 'luxon';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';

import Pagination from '@material-ui/lab/Pagination';

import { paper } from 'app/styles/core';
import { container } from 'app/styles/new-layout';

import useApi from 'app/context/useApi';
import useApp from 'app/context/useApp';

import ArticleSkeleton from 'app/components/loaders/ArticleSkeleton';

const useStyles = makeStyles(theme => ({
    pageTitle: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(5)
    },
    container: {
        ...container(theme),
        padding: theme.spacing(3)
    },
    articlePaper: {
        ...paper(theme),
        position: 'relative',
        marginBottom: theme.spacing(3)
    },
    empty: {
        paddingTop: theme.spacing(5),
        paddingBottom: theme.spacing(5),
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3)
    },
    articleExcerpt: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1)
    },
    groupLink: {
        verticalAlign: 'inherit'
    },

}));

export default function Articles(props) {

    const classes = useStyles();
    const api = useApi();
    const { app } = useApp();

    const [ articles, setArticles ] = useState([]);

    const [ page, setPage ] = useState(1);
    const [ rowsPerPage, setRowsPerPage ] = useState(10);

    const [ loading, setLoading ] = useState(false);

    const getArticles = () => {
        setLoading(true);

        api.get(`/article`)
            .then(res => setArticles(res.articles))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        getArticles();
    }, []);

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    };

    return (
        <div className={classes.container}>
            <Typography align="center" variant="h4" component="h2" className={classes.pageTitle}>
                Articles
            </Typography>
            {loading ? (
                <>
                    <ArticleSkeleton />
                    <ArticleSkeleton />
                    <ArticleSkeleton />
                    <ArticleSkeleton />
                    <ArticleSkeleton />
                </>
            ) : articles.length ? (
                <div>
                    {articles.slice(((page-1)*rowsPerPage), (((page-1)*rowsPerPage) + rowsPerPage)).map( a => (
                        <Paper className={classes.articlePaper} key={a.id}>
                            <Typography
                                component="h2"
                                color="textPrimary"
                                variant="h6"
                                >
                                {a.title}
                            </Typography>
                            <Typography
                                color="secondary"
                                variant="subtitle2"
                                component="div"
                                >
                                <span>
                                    {DateTime.fromISO(a.published_at).toLocaleString(DateTime.DATE_HUGE)}
                                </span>
                            </Typography>
                            <Typography
                                component="div"
                                color="textSecondary"
                                variant="body1"
                                className={classes.articleExcerpt}
                                >
                                {a.excerpt}
                            </Typography>
                            <Grid
                                container
                                spacing={3}
                                alignItems="center"
                                justify="space-between"
                                wrap="nowrap"
                                >
                                <Grid item>
                                <Typography variant='subtitle2' color="textSecondary">
                                    Published to&nbsp;
                                    {(a.group_id && a.group_id > 0) ? (
                                        <Tooltip title={"Viewable to " + a.group.title} aria-label={"Viewable to " + a.group.title}>
                                            <Link
                                                variant="subtitle2"
                                                component="button"
                                                className={classes.groupLink}
                                                color="secondary"
                                                >
                                                {a.group.title}
                                            </Link>
                                        </Tooltip>
                                    ) : (
                                        <Tooltip title="Viewable to everyone" aria-label="Viewable to everyone">
                                            <Link
                                                variant="subtitle2"
                                                component="button"
                                                className={classes.groupLink}
                                                color="secondary"
                                                >
                                                {app.club.name}
                                            </Link>
                                        </Tooltip>
                                    )}
                                </Typography>
                                </Grid>
                                <Grid item>
                                    <Button
                                        color="secondary"
                                        component={RouterLink}
                                        aria-label="Read Article"
                                        to={`/articles/${a.id}`}
                                        variant="contained"
                                        >
                                        Full Article
                                    </Button>
                                </Grid>
                            </Grid>
                        </Paper>
                    ))}
                    <div className={classes.alignCenter}>
                        <Pagination
                            count={Math.ceil((articles.length) / rowsPerPage)}
                            page={page}
                            onChange={handleChangePage}
                            className={classes.pagination}
                        />
                    </div>
                </div>
            ) : (
                <Paper className={classes.articlePaper}>
                    <Typography
                        align="center"
                        color="textSecondary"
                        variant="subtitle2"
                        className={classes.empty}
                        >
                        You don't have any articles available at this time. Check back often to get the latest news for your organization.
                    </Typography>
                </Paper>
            )}
        </div>
    );
}
